module.exports = __webpack_public_path__ + "static/personably-team-photo-d88ccc299d9c112cbaaccc801658c477.jpg";